export const decodeLineBreak = (text: string): string => {
    if (!text) return "";
    return text.replace(/<\/?br\s*\/?>/gi, "\n");
};